import { put } from 'redux-saga/effects';
import { websocketChannelSend, websocketOpenSubscriptionById } from '../../websocketReducer';

export function* subscriptionPingSubscribeSagas(channel: string) {
    yield put(
        websocketOpenSubscriptionById({
        id: 'PingRequest',
        type: 'PingRequest',
        process: function* (messageData: ReturnType<typeof JSON.parse>, channel: string) {
            const messageObject = {
                type: 'Ping',
                session: messageData.session,
                timestamp: messageData.timestamp,
            };
            const message = JSON.stringify(messageObject);
            yield put(
                websocketChannelSend({
                    channel,
                    message,
                    messageObject,
                }),
            );
        },
        channel,
    }));
};
